import { ElectronDetectionService } from "./electron-detection.service";

export function electronFactoryService(electronDetectionService: ElectronDetectionService,
    browserService: unknown, electronService: unknown) {
    return electronDetectionService.isElectron() ? electronService : browserService;
}